/* eslint-disable */

//tslint:disable

import { IModel, IModelResponse } from "@cian/http-api/shared/model";

export type TIsOfferDealCandidateModel = IModel<
  IIsOfferDealCandidateRequest,
  TIsOfferDealCandidateResponse
>;

export interface IIsOfferDealCandidateRequest {
  /** Id объявления **/
  offerId?: number | null;
}

export type TIsOfferDealCandidateResponse =
  | IIsOfferDealCandidateResponse200
  | IIsOfferDealCandidateResponse400;

export interface IIsOfferDealCandidateResponse200
  extends IModelResponse<IIsOfferDealCandidateResponse> {
  statusCode: 200;
}

export interface IIsOfferDealCandidateResponse400
  extends IModelResponse<IIsOfferDealCandidateResponseError> {
  statusCode: 400;
}

export interface IIsOfferDealCandidateResponse {
  /** Находится ли объявление в кандидате **/
  isDealCandidate: boolean;
  /** Версия сделки **/
  version?: EVersion | null;
}

export interface IIsOfferDealCandidateResponseError {
  errors: any[];
  message: string;
}

export type TResponses =
  | IIsOfferDealCandidateResponse
  | IIsOfferDealCandidateResponseError;

export enum EVersion {
  /** Старый вид сделок **/
  V1 = "v1",
  /** Сделка v2 **/
  V2 = "v2"
}

export interface IMappers<TResponse200, TResponse400> {
  200(response: IIsOfferDealCandidateResponse): TResponse200;
  400(response: IIsOfferDealCandidateResponseError): TResponse400;
}
